import { useEffect, useState } from "react";
import ReactPaginate from "react-paginate";

import classNames from "classnames";
import PropTypes from "prop-types";

import useViewport from "@/hooks/useViewport";
import NextIcon from "@/icons/next-icon.svg";
import PrevIcon from "@/icons/prev-icon.svg";

function Pagination({ totalPage, initialPage, getPaginateData, isScrollTop }) {
  const { width: pageWidth } = useViewport();
  const [pageRange, setPageRange] = useState(5);
  const [activePage, setActivePage] = useState(() =>
    initialPage ? initialPage : 0
  );

  useEffect(() => {
    setActivePage(initialPage);
  }, [initialPage]);

  useEffect(() => {
    calculatePageRange(pageWidth);
  }, [pageWidth]);

  const calculatePageRange = (pageWidth) => {
    if (pageWidth <= 640) {
      setPageRange(2);
    } else {
      setPageRange(5);
    }
  };

  const handlePageChange = (event) => {
    getPaginateData(event.selected);
    setActivePage(event.selected);

    if (isScrollTop) {
      window?.scrollTo({
        top: 0,
        left: 0,
        behavior: "smooth",
      });
    }
  };

  return (
    <div>
      <ReactPaginate
        previousLabel={
          <div
            className={classNames(
              {
                "cursor-default": activePage === 0,
              },
              "flex items-center space-x-[0.875rem]"
            )}
          >
            <PrevIcon className="h-[0.875rem] w-[0.5rem]" />
            <span className="text-[1rem]">Prev</span>
          </div>
        }
        nextLabel={
          <div
            className={classNames(
              {
                "cursor-default": activePage === totalPage - 1,
              },
              "flex items-center space-x-[0.875rem]"
            )}
          >
            <span className="text-[1rem]">Next</span>
            <NextIcon className="h-[0.875rem] w-[0.5rem]" />
          </div>
        }
        pageRangeDisplayed={pageRange}
        marginPagesDisplayed={1}
        pageCount={totalPage}
        onPageChange={handlePageChange}
        className="my-7 flex items-center justify-center"
        pageClassName="h-[1.8rem] w-[1.8rem] sm:h-[2.25rem] sm:w-[2.25rem] rounded-full flex items-center justify-center"
        activeClassName="bg-primary text-white"
        previousClassName="mr-[1.5rem] sm:mr-[2.5rem] text-gray-900"
        nextClassName="ml-[1.5rem] sm:ml-[2.5rem] text-gray-900"
        disabledClassName="text-grayDisplay-200"
        forcePage={activePage}
      />
    </div>
  );
}

Pagination.propTypes = {
  initialPage: PropTypes.number,
  getPaginateData: PropTypes.func,
  totalPage: PropTypes.number,
};

Pagination.defaultProps = {
  totalPage: 1,
  isScrollTop: true,
};

export default Pagination;
